import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { WeeklyGoalItem } from "@/components/ui/goals/weekly-goal-item"
import { BookOpen, Video, Brain } from "lucide-react"

export function WeeklyGoalsSection() {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardHeader>
        <CardTitle className="text-xl text-slate-900">Your Personalized Weekly Goals</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <WeeklyGoalItem
          icon={<BookOpen className="w-8 h-8 text-indigo-600" />}
          title="Complete 3 Web Dev Modules"
          description="Learn about HTML, CSS, and basic JavaScript."
          progress={66}
          completed={2}
          total={3}
        />
        <WeeklyGoalItem
          icon={<Video className="w-8 h-8 text-indigo-600" />}
          title="Watch 5 Career Videos"
          description="Explore different tech career paths and interviews."
          progress={100}
          completed={5}
          total={5}
        />
        <WeeklyGoalItem
          icon={<Brain className="w-8 h-8 text-indigo-600" />}
          title="Take 1 Personality Quiz"
          description="Discover skills that match your personality."
          progress={0}
          completed={0}
          total={1}
        />
      </CardContent>
    </Card>
  )
}
